//
// locales/glitch/lv.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/lv';
import localeData from 'react-intl/locale-data/lv.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
